import { createSlice } from "@reduxjs/toolkit";
import ProposalItemSlice from "./ProposalItemSlice";

const initialState = {
  proposalData: [],
  proposalTourPlan: [],
  proposalItems: [],
  proposalLogistic: [],
  fees: [],
  transactionFees: [],
  summeryData: [],
  proposalPkMaterials: [],
};
const ProposalSummeryDataSlice = createSlice({
  name: "summeryData",
  initialState,
  reducers: {
    setSummeryInitState(state, action) {
      const proposalData = action?.payload?.proposalData;
      const proposalTourPlan = action?.payload?.proposalTourPlan;
      const proposalItems = action?.payload?.proposalItems;
      const proposalLogistic = action?.payload?.proposalLogistic;
      const fees = action?.payload?.fees;
      const transactionFees = action?.payload?.transportFees;
      const summeryData = action?.payload?.summeryData;
      const proposalPkMaterials = action?.payload?.proposalPkMaterials;

      state.proposalData = proposalData;
      state.proposalTourPlan = proposalTourPlan;
      state.proposalItems = proposalItems;
      state.proposalLogistic = proposalLogistic;
      state.fees = fees;
      state.transactionFees = transactionFees;
      state.summeryData = summeryData;
      state.proposalPkMaterials = proposalPkMaterials;
    },
  },
});

export const ProposalSummaryDataActions = ProposalSummeryDataSlice.actions;
export default ProposalSummeryDataSlice;
